<template>
  <div  >
    <loading :active.sync="loaderGuardar" :can-cancel="false" :is-full-page="true"></loading>

    <b-row class="text-left ml-3">
      <b-col class="textForm" cols="4" md="4" lg="4" xl="4">
        <span v-if="tipoFlujoFisico === 1" style="color: #62B6C2; font-weight: 600">Prótesis fija</span>
        <span v-if="tipoFlujoFisico === 2" style="color: #62B6C2; font-weight: 600">Prótesis Removible</span>


        <div class="mt-4">
          <span >Elementos enviados a laboratorio <span style="color: red">*</span></span>
          <v-select
              v-model="protesis.elementos"
              placeholder="Selecciona uno o multiples elementos"
              id="idElemento"
              label="descripcion"
              required
              :options="listaElementosProps"
              :reduce="(variable) => variable.idElemento"
              multiple
          />
        </div>
        <br/>
        <br/>

        <span style="color: #62B6C2; font-weight: 500">Color para los Od´s seleccionados </span>
        <div class="mt-3">
        <span>Tipo de colorimetro <span style="color: red">*</span></span>
          <v-select
              v-model="protesis.idColorimetro"
              style="width: 80%;"
              placeholder="Selecciona un colorimetro"
              id="idColorimetro"
              label="nombre"
              required
              :options="listaColorimetrosProps"
              :reduce="(variable) => variable.idColorimetro"
              :clearable="false"
              @input="filtrarColores(protesis.idColorimetro)"
          ><span slot="no-options">No hay valores configurados disponibles</span>
          </v-select>
        </div>
      </b-col>
    </b-row>

    <!--    LÓGICA DE COLORES PARA ODS SELECCIONADOS    -->
    <b-row class="text-left ml-3">
      <b-col class="textForm" cols="3" md="3" lg="3" xl="3">
        <b-card class="mt-3" style="width: 110%;height: 200px;">
          <b-row style="margin-top: -10px;" v-if="dientesSeleccionados.length > 1">
            <b-col cols="10"><span>¿Mismo color para todos los ods? </span></b-col>
            <b-col cols="2"> <b-form-checkbox
                @input="seleccionarTodosLosDiente(protesis.mismoColor, dientesSeleccionados[indexTab], dientesSeleccionados[indexTab].aplicaEnTodosTercios  )"
                v-model="protesis.mismoColor"
                :disabled="(dientesSeleccionados[indexTab].aplicaEnTodosTercios && dientesSeleccionados[indexTab].idColorimetroColor === null)
                            ||( !dientesSeleccionados[indexTab].aplicaEnTodosTercios && (dientesSeleccionados[indexTab].tercioCervical === null ||
                            dientesSeleccionados[indexTab].tercioIncisalOclusal === null || dientesSeleccionados[indexTab].tercioMedio === null) )"
            />
            </b-col>
          </b-row>

          <div  style="overflow-y: scroll; max-height: 150px;">
            <b-card v-for="(diente, index) in dientesSeleccionados" :key="diente.idTratamientoProgramado"
                    style="height: 33px; border-color: #CDCDCD; cursor: pointer" class="mt-1"
                    :style="indexTab === index ? 'border-color: #A6CBD1;color: #0069A9;' : 'color: #CDCDCD;  '"
                    @click="asignarColorByDiente(diente, index)"
            >

              <div v-if="protesis.mismoColor" style="display: flex; justify-content: left;margin-top: -15px;">
                <div class="circleSelect" ><span> {{index +1}} </span></div>
                <span class="ml-3" style="color: #6AACB6 !important;">
                  <em class="dienteProtesis" style="width: 1.5em;"/>
                  OD {{diente.numeroDiente}}
                </span>
              </div>
              <div v-else style="display: flex; justify-content: left;margin-top: -15px;">
                <div class="circle" :style="indexTab === index ? 'background-color: #6AACB6;color: #FFFFFF;' : 'background-color: #CDCDCD;  '" ><span> {{index +1}} </span></div>
                <div class="mt-1 ml-3" style="display: flex;" >
                  <div>
                    <em class="dienteProtesis" style="width: 1.2em;"/>
                  </div>
                  <span class="ml-2">
                    OD {{diente.numeroDiente}}
                  </span>
                </div>
              </div>
            </b-card>
          </div>


        </b-card>
      </b-col>
<!--    Cards para color por cada od      -->
      <b-col>
        <div class="textForm ml-3">
          <span v-if="protesis.mismoColor" style="font-weight: 500">Color para todos los Od´s</span>
          <span v-else-if="!protesis.mismoColor" style="font-weight: 500">Órgano dental {{dientesSeleccionados[indexTab].numeroDiente}}</span>

          <br/>
          <div style="display: inline-flex" class="mt-3" v-if="seConfiguranTercios">
            <span>¿El color aplica para todos los tercios?</span>
            <b-form-checkbox class="ml-3"
                             v-model="dientesSeleccionados[indexTab].aplicaEnTodosTercios"
                             @input="limpiarColores()"/>
          </div>
          <div v-if="dientesSeleccionados[indexTab].aplicaEnTodosTercios" class="mt-3">
            <span>Color del diente <span style="color: red">*</span></span>
            <v-select
                v-model="dientesSeleccionados[indexTab].idColorimetroColor"
                style="width: 30%;"
                placeholder="Selecciona un color"
                required
                label="nombre"
                :options="listaColores"
                :reduce="(variable) => variable.idColorimetroColor"
                :clearable="false"
            />
          </div>
        </div>
        <b-row class="ml-3 mt-3" v-if="!dientesSeleccionados[indexTab].aplicaEnTodosTercios">
          <b-col class="textForm" cols="4" md="4" lg="4" xl="4">
            <span>Tercio incisal/oclusal <span style="color: red">*</span></span>
            <v-select
                v-model="dientesSeleccionados[indexTab].tercioIncisalOclusal"
                style="width: 80%;"
                placeholder="Selecciona una opción"
                id="tercioIncisal"
                label="nombre"
                required
                :options="listaColores"
                :reduce="(variable) => variable.idColorimetroColor"
                :clearable="false"
            />
          </b-col>
          <b-col class="textForm" cols="4" md="4" lg="4" xl="4">
            <span>Tercio medio <span style="color: red">*</span></span>
            <v-select
                v-model="dientesSeleccionados[indexTab].tercioMedio"
                style="width: 80%;"
                placeholder="Selecciona una opción"
                id="tercioMedio"
                label="nombre"
                required
                :options="listaColores"
                :reduce="(variable) => variable.idColorimetroColor"
                :clearable="false"
            />
          </b-col>
          <b-col class="textForm" cols="4" md="4" lg="4" xl="4">
            <span>Tercio cervical <span style="color: red">*</span></span>
            <v-select
                v-model="dientesSeleccionados[indexTab].tercioCervical"
                style="width: 80%;"
                placeholder="Selecciona una opción"
                id="terciocervical"
                label="nombre"
                required
                :options="listaColores"
                :reduce="(variable) => variable.idColorimetroColor"
                :clearable="false"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>


    <!--    LÓGICA DE COLORES PARA RESTAURACIONES IMPLANTOSOPORTADAS    -->
    <div v-if="aplicaRestauracionesProp">
      <b-row class="text-left ml-3">
        <b-col class="textForm mt-4" cols="4" md="4" lg="4" xl="4">
        <span style="color: #62B6C2; font-weight: 500">Restauraciones implantosportadas </span>
        </b-col>
      </b-row>
      <b-row class="text-left textForm ml-3">
        <b-col class="textForm mt-4" cols="4" md="4" lg="4" xl="4">
          <span>Marca <span style="color: red">*</span></span>
          <v-select
              v-model="protesis.idMarca"
              style="width: 80%;"
              placeholder="Selecciona una opción"
              id="idMarca"
              label="descripcion"
              required
              :reduce="(variable) => variable.idMarca"
              :clearable="false"
              :options="listaMarcasProps"
          />
        </b-col>
        <b-col class="textForm mt-4" cols="4" md="4" lg="4" xl="4">
          <span>Diametro <span style="color: red">*</span></span>
          <v-select
              v-model="protesis.idDiametro"
              style="width: 80%;"
              placeholder="Selecciona una opción"
              id="idDiametro"
              label="descripcion"
              required
              :reduce="(variable) => variable.idDiametro"
              :clearable="false"
              :options="listaDiametroProps"
          />
        </b-col>
        <b-col class="textForm mt-4" cols="4" md="4" lg="4" xl="4">
          <span>Conexión<span style="color: red">*</span></span>
          <v-select
              v-model="protesis.idConexion"
              style="width: 80%;"
              placeholder="Selecciona una opción"
              id="idConexion"
              label="descripcion"
              required
              :reduce="(variable) => variable.idConexion"
              :clearable="false"
              :options="listaConexionProps"
          />
        </b-col>
      </b-row>
    </div>

<!--    LÓGICA DE DETALLES ADICIONALES    -->
    <div>
      <b-row class="text-left ml-3">
        <b-col class="textForm mt-4" cols="4" md="4" lg="4" xl="4">
          <span style="color: #62B6C2; font-weight: 500">Detalles adicionales  </span>
        </b-col>
      </b-row>
      <b-row class="text-left textForm ml-3">
        <b-col class="textForm mt-4" cols="6" md="6" lg="6" xl="6">
          <span>Agregar imágenes <span style="color: red">*</span></span>
          <div class="m-2">
            <input type="file" ref="inputArchivosAdicionales" multiple @change="cargarArchivos($event)" style="display: none;">
            <b-button variant="outline-primary" class="rounded-pill" size="sm" @click="$refs.inputArchivosAdicionales.click()">
              Agregar archivos
            </b-button>

            <em class= "trash_svg btn-agregar-archivos-ad"
                v-b-tooltip.hover.topright.v-light
                title="Eliminar todos los archivos adicionales"
                v-if="protesis.listaArchivosGuardar.length > 0"
                @click="eliminarArchivosTodos()"
            ></em>
          </div>
        </b-col>
        <b-col class="textForm mt-4" cols="6" md="6" lg="6" xl="6">
          <span>Observaciones <span style="color: red">*</span></span>
          <div>
            <b-form-textarea
                style="resize:both;"
                class="form-control form-control-sm"
                placeholder="Ingresa las observaciones"
                v-model="protesis.observaciones"
                type="text"
            ></b-form-textarea>
          </div>
        </b-col>
        <b-col class="textForm mt-4" cols="6" md="6" lg="6" xl="6" v-if="protesis.listaArchivosGuardar.length > 0">
          <span class="textForm">Archivos cargados</span>
          <br>
          <div class="archivos-container">
            <div class="archivo-miniatura" v-for="(item, index) of protesis.listaArchivosGuardar" :key="index">
              <div class="logo-archivo">
                <img src="../../../assets/laboratorio/pdf.svg" alt="logo-pdf-archivo">
                <em v-if="!item.progreso" class="close_outline_svg" style="width: 14px; cursor: pointer; position: absolute; right: 7px;"
                    v-b-tooltip.hover.topleft.v-light
                    title="Eliminar"
                    @click="eliminarArchivo(index)"
                ></em>

                <!-- Mostrar spinner mientras se sube -->
                <b-spinner small
                           v-else-if="item.progreso > 0 && item.progreso < 100"
                           style=" width: 14px; position: absolute; right: 7px;"
                ></b-spinner>

                <!-- Mostrar ícono de éxito si ya se subió -->
                <em
                    v-else-if="item.progreso === 100"
                    class="check_green_svg"
                    style="width: 14px; position: absolute; right: 7px;"
                    v-b-tooltip.hover.topleft.v-light
                    title="Archivo subido con éxito"
                ></em>

              </div>
              <div class="archivo-name">
                <span style="font-size: xx-small">{{ item.nombreArchivo }}</span>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>


    </div>

    <div class="text-center mt-4">
      <b-button style="background: #1B81AF" variant="primary" pill size="sm" @click="finalizar()"
                :disabled="botonDeshabilitado"
      >
        <span >Finalizar</span>
        <b-spinner v-if="loaderGuardar" variant="info" small/>
      </b-button>
    </div>

  </div>
</template>
<script>
import {S3Client} from "@aws-sdk/client-s3";
import {Upload} from "@aws-sdk/lib-storage";
import moment from "moment/moment";
import {AwsService} from "@/apiServices/aws/AwsService";

export default {
  name: "ProtesisFijaRemovible",
  props: {
    listaElementosProps: Array,
    odtProp: Object,
    dientesSeleccionados: Array,
    listaColorimetrosProps: Array,
    tipoFlujoFisico: Number,
    listaDiametroProps: Array,
    listaConexionProps: Array,
    listaMarcasProps: Array,
    ruta: String,
    idPaciente: Number,
    aplicaRestauracionesProp: Boolean,
    loader: Boolean,
  },
  data: () => ({
    protesis: {
      elementos: [],
      idColorimetro: null,
      mismoColor: false,

      idMarca: null,
      idDiametro: null,
      idConexion: null,
      listaArchivosGuardar: [],
      observaciones: null,
      tipoFlujoFisico: 1,
      aplicaRestauraciones:false,
    },
    dientes: [],
    listaColores: [],

    awsServicio: new AwsService(),
    token: null,
    hoy : null,
    colorDiente: null,
    indexTab: 0,
    loaderGuardar: false,
    seConfiguranTercios: false,
  }),
  watch:{

  },
  async created() {
    this.hoy = this.$moment().format("DD-MM-YYYY");
    this.token = this.$localStorageService.getTokenAWS();
    console.log(this.token);
    this.protesis.tipoFlujoFisico = this.tipoFlujoFisico;
    this.protesis.aplicaRestauraciones = this.aplicaRestauracionesProp;
    await this.validarTokenAWS();
  },
  computed: {
    botonDeshabilitado() {
      return (
          this.protesis.elementos.length === 0 ||
          this.protesis.idColorimetro === null ||
          this.loaderGuardar ||
          this.dientesSeleccionados.some(d => {
            if (d.aplicaEnTodosTercios){
              return d.idColorimetroColor === null;
            }else {
              return (
                  d.tercioMedio === null ||
                  d.tercioIncisalOclusal === null ||
                  d.tercioCervical === null
              );
            }
          }) ||

              this.protesis.observaciones === null
      );
    },
  },
  methods: {
    limpiarColores(){
      this.protesis.mismoColor = false;
      this.dientesSeleccionados.forEach(od => {
        od.idColorimetroColor = null;
        od.tercioCervical = null;
        od.tercioIncisalOclusal = null;
        od.tercioMedio = null
      })
    },
    seleccionarTodosLosDiente(mismoColor, diente, aplicaEnTodosLosTercios){
      if (mismoColor && aplicaEnTodosLosTercios){
        this.dientesSeleccionados.forEach(od => {
          od.aplicaEnTodosTercios = diente.aplicaEnTodosTercios
          od.idColorimetroColor = diente.idColorimetroColor;
        })
      }

      if (mismoColor && !aplicaEnTodosLosTercios){
        this.dientesSeleccionados.forEach(od => {
          od.aplicaEnTodosTercios = diente.aplicaEnTodosTercios
          od.tercioCervical = diente.tercioCervical;
          od.tercioIncisalOclusal = diente.tercioIncisalOclusal;
          od.tercioMedio = diente.tercioMedio;
        })
      }

      console.log(mismoColor, this.dientesSeleccionados, diente, aplicaEnTodosLosTercios, "...............")

    },
    asignarColorByDiente(diente, index){
      console.log(diente, index)
      this.indexTab = index;
    },
    filtrarColores(idColorimetro){
      this.protesis.mismoColor = false;
      this.seConfiguranTercios = false
      this.listaColores = []
      this.listaColorimetrosProps.forEach(c => {
        if (c.idColorimetro === idColorimetro){
          this.seConfiguranTercios = c.configuraTercios;

          c.coloresId.forEach(color => {
            this.listaColores.push(color)
          })
        }
      })
      this.dientesSeleccionados.forEach(d => {
        d.idColorimetroColor = null;
        d.tercioIncisalOclusal = null;
        d.tercioMedio = null;
        d.tercioCervical = null;
      })
      //this.listaColores = this.listaColorimetrosProps.filter(cp => cp.idColorimetro === this.protesis.idColorimetro).colores

    },
    async finalizar(){

      if (this.protesis.mismoColor){
        this.dientesSeleccionados.forEach(d => {
          if (this.dientesSeleccionados[0].aplicaEnTodosTercios){
            d.idColorimetroColor = this.dientesSeleccionados[0].idColorimetroColor
          } else {
            d.tercioIncisalOclusal = this.dientesSeleccionados[0].tercioIncisalOclusal
            d.tercioMedio = this.dientesSeleccionados[0].tercioMedio
            d.tercioCervical = this.dientesSeleccionados[0].tercioCervical
          }
        })
      }

      await this.guardarArchivos();
    },

    /* ----- FUNCIONES PARA CARGA DE ARCHIVOS -------- */
    mostrarErrorLimite(mensajePersonalizado = null) {
      const mensaje = mensajePersonalizado || 'Ya has alcanzado el límite máximo de 5 archivos';

      this.$swal({
        icon: 'error',
        title: 'Límite de archivos',
        text: mensaje,
        confirmButtonText: 'Entendido'
      });
    },
    async cargarArchivos(e) {
      const MAX_ARCHIVOS = 5; // Define tu límite máximo
      const files = e.target.files || e.dataTransfer.files;

      // Validación estricta
      if (this.protesis.listaArchivosGuardar.length >= MAX_ARCHIVOS || this.protesis.listaArchivosGuardar.length === MAX_ARCHIVOS) {
        this.mostrarErrorLimite();
        e.target.value = '';
        return;
      }

      if (this.protesis.listaArchivosGuardar.length + files.length > MAX_ARCHIVOS) {
        this.mostrarErrorLimite(`Estás intentando subir ${files.length} archivos, pero solo puedes subir ${MAX_ARCHIVOS - this.protesis.listaArchivosGuardar.length} más`);
        e.target.value = '';
        return;
      }


      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const extension = file.name.split('.').pop().toLowerCase();
        const timestamp = this.$moment().format("YYYYMMDDHHmmssSSS");
        const nombreBase = 'ARCHIVO_AD' + " " + timestamp; // Elimina la extensión

        this.protesis.listaArchivosGuardar.push({
          file: file,
          nombreArchivo: `${this.idPaciente}_${nombreBase}${i}.${extension}`,
          extension: extension,
          generadoEscaner: false,
        });
      }
      e.target.value = '';
    },

    eliminarArchivosTodos() {
      console.log(this.protesis);
      // Si no hay archivos adicionales
      if (this.protesis.listaArchivosGuardar.length === 0) {
        this.$swal({
          title: 'No hay archivos para eliminar',
          text: 'No se encontraron archivos adicionales',
          icon: 'info',
          timer: 1500
        });
        return;
      }

      // Confirmación
      this.$swal({
        title: '¿Eliminar todos los archivos?',
        html: `Estás por eliminar <b>${this.protesis.listaArchivosGuardar.length} archivo(s)</b>:<br>
           <ul class="text-left mt-2">
             ${this.protesis.listaArchivosGuardar.map(f => `<li>${f.nombreArchivo}</li>`).join('')}
           </ul>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar todos',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: 'Eliminados',
            html: `Se eliminaron ${this.protesis.listaArchivosGuardar.length} archivo(s)`,
            icon: 'success',
            timer: 3000
          });
          this.protesis.listaArchivosGuardar = [];
        }
      });
    },

    eliminarArchivo(index) {
      this.$swal({
        title: '¿Eliminar archivo?',
        text: `Estás por eliminar "${this.protesis.listaArchivosGuardar[index].nombreArchivo}"`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // Elimina el archivo del array
          this.protesis.listaArchivosGuardar.splice(index, 1);

          this.$swal({
            title: 'Eliminado',
            text: 'El archivo ha sido removido',
            icon: 'success',
            timer: 1500
          });
        }
      });
    },

    async guardarArchivos() {

      await this.validarTokenAWS();

      if (this.protesis.listaArchivosGuardar.length === 0) {
        this.$emit('finalizarOdt', this.protesis);
        return;
      }

      this.loaderArchivo = true;
      this.loaderGuardar = true

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      let ruta = this.ruta.replace("#id_paciente", this.idPaciente.toString());
      let nombreCarpeta = `ODT ${this.hoy}`;

      try {
        for (const [index, archivo] of this.protesis.listaArchivosGuardar.entries()) {
          try {
            let tipoCarpeta = "PROTESIS";

            let rutaDirectorio = `${ruta}/${nombreCarpeta}/${tipoCarpeta}`;
            let filePath = `${rutaDirectorio}/${archivo.nombreArchivo}`;

            this.protesis.listaArchivosGuardar[index].urlRuta = filePath;

            const input = {
              Bucket: this.token.nombreBucket,
              Key: filePath,
              Body: archivo.file,
              ContentType: archivo.file.type,
            };

            const upload = new Upload({
              client: client,
              params: input,
              partSize: 5 * 1024 * 1024,
              queueSize: 4,
            });

            upload.on("httpUploadProgress", (progress) => {
              const porcentaje = Math.round((progress.loaded / progress.total) * 100);
              this.$set(this.protesis.listaArchivosGuardar[index], "progreso", porcentaje);
            });

            await upload.done();

          } catch (error) {
            console.error(`Error al subir el archivo ${archivo.nombreArchivo}:`, error);
            throw error;
          }
        }

        this.$emit('finalizarOdt', this.protesis)

      } catch (error) {
        console.error("Error en el proceso:", error);

        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: `Hubo un problema: ${error.message}`,
        });
      } finally {
        this.loaderArchivo = false; // esto sí puedes mantener si quieres desactivar el loader
      }
    },

    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAcceso().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWS(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAcceso().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWS(this.token)
        })
      }
    },

    reset(){
      this.protesis = {
        elementos: [],
        idColorimetro: null,
        mismoColor: false,
        idMarca: null,
        idDiametro: null,
        idConexion: null,
        listaArchivosGuardar: [],
        observaciones: null,
        tipoFlujoFisico: 1,
        aplicaRestauraciones:false,
      }
    }

  }
}
</script>
<style scoped>
.textForm {
  font-size: 11px;
}
.circle {
  border: 1px solid;
  border-radius: 50%;
  display: inline-block;
  padding: 9px;
  width: 24px;
  height: 24px;
  line-height: 1px;
  background-color: #CDCDCD;
  color: white;
}

.circleSelect {
  border: 1px solid;
  border-radius: 50%;
  display: inline-block;
  padding: 9px;
  width: 24px;
  height: 24px;
  line-height: 1px;
  background-color: #6AACB6;
  color: white;
}
.archivo-miniatura{
  width: 69px;
  min-height: 60px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.archivos-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.archivo-miniatura .logo-archivo{
  display: flex;
  justify-content: center;
}

.archivo-miniatura .archivo-name{
  font-size: xx-small;
  line-height: normal;
}

.btn-agregar-archivos-ad{
  margin-left: 10px;
  cursor: pointer;
  position: absolute;
  scale: 1.3;
  top: 28px;
}
</style>
